import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  browserFromUserAgent,
  deviceIconFromUserAgent,
  platformFromUserAgent,
} from '@utils/userAgent';

/** Device identity for one session: what browser, on what platform. */
const SessionDeviceCell: React.FC<{ userAgent: string | null }> = ({ userAgent }) => {
  const { t } = useTranslation();
  const Icon = deviceIconFromUserAgent(userAgent);
  const browser = browserFromUserAgent(userAgent);
  const platform = platformFromUserAgent(userAgent);

  return (
    <div className="flex items-center gap-3">
      <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-muted text-muted-foreground">
        <Icon className="size-4" strokeWidth={1.9} />
      </span>
      <span className="min-w-0">
        <span className="block truncate text-sm font-medium">
          {platform ?? t('settings.security.unknownDevice')}
        </span>
        <span className="block truncate text-xs text-muted-foreground">
          {browser ?? t('profile.unknownBrowser')}
        </span>
      </span>
    </div>
  );
};

export default SessionDeviceCell;
